import { useQuery } from '@tanstack/react-query';

import { getDebitCardSigningOrder } from '@/react-query/services/order';

import { DebitCardOrderStatus } from '@generated-types';

export const useGetDebitCardSigningOrder = (accountNumber: string | null, returnStatus: string | null) => {
    return useQuery<DebitCardOrderStatus | null>({
        queryKey: ['orderCardStatusV2', accountNumber, returnStatus],
        queryFn: () => getDebitCardSigningOrder(accountNumber!, returnStatus),
        enabled: !!accountNumber,
    });
};
